import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Table,
  Input,
  Row,
  Col,
  Badge,
} from "reactstrap";
import { getContacts } from "../../api/apiUrlConst";

function ContactList() {
  const [contacts, setContacts] = useState<any[]>([]);
  const [search, setSearch] = useState("");

  const loadData = async () => {
    const res = await getContacts();
    setContacts(res);
  };

  useEffect(() => {
    loadData();
  }, []);

  // 🔍 Filter
  const filtered = contacts.filter((c) =>
    c.name.toLowerCase().includes(search.toLowerCase()) ||
    c.email.toLowerCase().includes(search.toLowerCase()) ||
    c.phoneNumber.includes(search)
  );

  // 📊 Stats
  const total = contacts.length;
  const today = contacts.filter(
    (c) =>
      new Date(c.contactedAt).toDateString() === new Date().toDateString()
  ).length;

  const purposeColor: any = {
    Training: "primary",
    Consulting: "success",
    HR: "warning",
  };

  return (
    <div className="p-3">

     

      {/* 🔥 Main Card */}
      <Card
        className="shadow-lg border-0"
        style={{ borderRadius: "20px" }}
      >
        <CardBody>

          {/* Header */}
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h4 className="fw-bold mb-0">Contact Enquiries</h4>

            <Input
              placeholder="Search..."
              style={{ maxWidth: "250px" }}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>

          {/* Table */}
          <Table hover responsive className="align-middle">
            <thead style={{ background: "#f8f9fa" }}>
              <tr>
                <th>Name</th>
                <th>Phone</th>
                <th>Email</th>
                <th>Purpose</th>
                <th>Message</th>
                <th>Date</th>
              </tr>
            </thead>

            <tbody>
              {filtered.map((c: any, i) => (
                <tr key={i} className="table-row">
                  <td className="fw-semibold">{c.name}</td>

                  <td>{c.phoneNumber}</td>

                  <td className="text-muted">{c.email}</td>

                  <td>
                    <Badge color={purposeColor[c.purpose] || "secondary"}>
                      {c.purpose}
                    </Badge>
                  </td>

                  <td style={{ maxWidth: "250px" }}>
                    <div
                      style={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {c.message || "-"}
                    </div>
                  </td>

                  <td className="text-muted">
                    {new Date(c.contactedAt).toLocaleString()}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>

        </CardBody>
      </Card>

      {/* ✨ Extra Styling */}
      <style>
        {`
          .table-row:hover {
            background-color: #f1f3f5;
            transition: 0.2s;
          }
        `}
      </style>
    </div>
  );
}

export default ContactList;